import { Tab, Tabs } from '@mui/material'
import React, { ReactElement } from 'react'
import { colors } from 'styles/variables'

type StyledTabsProps = {
  value?: number
  onChange: (event: React.ChangeEvent<unknown>, newValue: number) => void
  children?: ReactElement | ReactElement[]
}

export const StyledTabs = (props: StyledTabsProps): React.JSX.Element => (
  <Tabs
    {...props}
    sx={{
      marginTop: 1,
      '& .MuiTabs-indicator': {
        display: 'none',
      },
    }}
    slotProps={{
      indicator: { children: <div /> },
    }}
  />
)

type StyledTabProps = {
  value?: number
  label: ReactElement
  disabled?: boolean
}

export const StyledTab = (props: StyledTabProps): React.JSX.Element => (
  <Tab
    className="Tab"
    {...props}
    sx={{
      borderColor: colors.grey6,
      borderTop: 1.2,
      borderLeft: 1.2,
      borderRight: 1.2,
      borderStyle: `solid`,
      borderTopLeftRadius: 3,
      borderTopRightRadius: 3,
      textTransform: `uppercase`,
      color: colors.grey6,
      fontSize: 15,
      marginRight: 1,
      marginLeft: 1,
      backgroundColor: colors.white,
      boxShadow: `0 0 5px 0 rgba(0,0,0,0.2)`,
    }}
  />
)
